

































import { Vue, Component, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import ICompanySettings from '@/store/models/ICompanySettings';
import ISystemSettings from '@/store/models/ISystemSettings';
import CompanySettingsApi from '@/store/api/CompanySettingsApi';
import SystemSettingsApi from '@/store/api/SystemSettingsApi';
import CompanySettingsSelector from '@/components/selectors/Settings/CompanySettingsSelector.vue';
import SystemSettingsSelector from '@/components/selectors/Settings/SystemSettingsSelector.vue';
import ICompany from '@/store/models/ICompany';
import CompanyApi from '@/store/api/CompanyApi';
@Component({
    components: {
        Snackbar,
        CompanySettingsSelector,
        SystemSettingsSelector
    }
})
export default class CompanySettings extends Vue {
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    companySettingsList : ICompanySettings[] = [];
    systemSettingsList : ISystemSettings[] = [];
    companySettingsApi : CompanySettingsApi;
    systemSettingsApi : SystemSettingsApi;
    companyApi : CompanyApi;
    companiesList: ICompany[] = [];

    constructor() {
        super();
        this.companySettingsApi = new CompanySettingsApi();
        this.systemSettingsApi = new SystemSettingsApi();
        this.companyApi = new CompanyApi();
    }

    created() {
        this.getPermissions();
        this.getCompanySettings();
        this.getSystemSettings();
        this.getCompanies();
    }

    async getCompanies() {
        this.companiesList = await this.companyApi.GetCompanies();
    }

    async getCompanySettings() {
        this.companySettingsList = await this.companySettingsApi.GetCompanySettings();
    }

    async getSystemSettings() {
        this.systemSettingsList = await this.systemSettingsApi.GetSystemSettings();
    }
    
    async saveCompanySettings (companySetting: ICompanySettings) {
        const id = await this.companySettingsApi.SaveCompanySettings(companySetting);
        if (id) {
            companySetting.id = id;
            this.companySettingsList = [companySetting].concat(this.companySettingsList);
            this.showMessageInfo(`The company setting has been successfully saved`);
        } else {
            const errors: string = this.companySettingsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async editCompanySettings (companySetting: ICompanySettings) {
        let result : boolean = await this.companySettingsApi.UpdateCompanySettings(companySetting);
        if (result) {
            this.showMessageInfo(`The company setting has been successfully edited`);
        } else {
            const errors: string = this.companySettingsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    deleteCompanySettings(companySetting: ICompanySettings) {
        confirm('Are you sure you want to delete this company setting?') && this.deleteCompanySettingsItem(companySetting);
    }

    async deleteCompanySettingsItem(companySetting: ICompanySettings) {
        let result: boolean = await this.companySettingsApi.DeleteCompanySettings(companySetting.id);
        if (result) {
            const index = this.companySettingsList.indexOf(companySetting);
            this.companySettingsList.splice(index, 1);
            this.showMessageInfo(`The company setting has been successfully deleted`);
        } else {
            const errors: string = this.companySettingsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async saveSystemSettings (systemSetting: ISystemSettings) {
        const id = await this.systemSettingsApi.SaveSystemSettings(systemSetting);
        if (id) {
            systemSetting.id = id;
            this.systemSettingsList = [systemSetting].concat(this.systemSettingsList);
            this.showMessageInfo(`The system setting has been successfully saved`);
        } else {
            const errors: string = this.systemSettingsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    async editSystemSettings (systemSetting: ISystemSettings) {
        let result : boolean = await this.systemSettingsApi.UpdateSystemSettings(systemSetting);
        if (result) {
            this.showMessageInfo(`The system setting has been successfully edited`);
        } else {
            const errors: string = this.systemSettingsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }

    deleteSystemSettings(systemSetting: ISystemSettings) {
        confirm('Are you sure you want to delete this system setting?') && this.deleteSystemSettingsItem(systemSetting);
    }

    async deleteSystemSettingsItem(systemSetting: ISystemSettings) {
        let result: boolean = await this.systemSettingsApi.DeleteSystemSettings(systemSetting.id);
        if (result) {
            const index = this.systemSettingsList.indexOf(systemSetting);
            this.systemSettingsList.splice(index, 1);
            this.showMessageInfo(`The system setting has been successfully deleted`);
        } else {
            const errors: string = this.systemSettingsApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
    }
    
    getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Settings"));
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
